import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import vSelect from 'vue-select'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

import { i18n, loadLanguageAsync } from '@/translations/i18n'
import { snakeToPascal, cleanSource, toggleModal, toggleBodyClass, toggleHtmlClass } from '@/helper'
import installCustomRules from '@/validation/rules'
import { hasFeature } from '@/mixins'
import { clickOutside } from '@/directives'

import App from '@/app/App'
import QuickCart from '@/components/QuickCart'

import 'vue-select/dist/vue-select.css'
import store from '@/store'
import DynamicLink from '@/components/modules/DynamicLink'
import Fragment from 'vue-fragment'

// bind store on window, to dispatch actions from ruby
window.store = store

configure({
  classes: {
        // valid: 'is-valid',
    invalid: 'fl-err',
        // dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
  },
})

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

installCustomRules(extend)

Vue.component('vue-select', vSelect)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.config.productionTip = false

Vue.prototype.cleanSource = cleanSource
Vue.prototype.snakeToPascal = snakeToPascal
Vue.prototype.toggleModal = toggleModal
Vue.prototype.toggleBodyClass = toggleBodyClass
Vue.prototype.toggleHtmlClass = toggleHtmlClass
Vue.prototype.customer = process.env.customer

Vue.use(PerfectScrollbar)

Vue.directive('click-outside', clickOutside)

Vue.mixin(hasFeature)

loadLanguageAsync(window.config.locale || process.env.VUE_APP_I18N_FORMATED_LOCALE)

if (document.getElementById('checkout-purchase')) {
  new Vue({
    i18n,
    store,
    render: h => h(App),
  }).$mount('#checkout-purchase')
}

if (document.getElementById('quick-cart')) {
  new Vue({
    i18n,
    store,
    render: h => h(QuickCart),
  }).$mount('#quick-cart')
}

// Obtain all auth-field elements
const elements = document.getElementsByTagName('nav-links')

if (elements.length) {
  // Support multiple root elements
  Vue.use(Fragment.Plugin)

  // Convert HTMLCollection to array
  const arr = Array.prototype.slice.call(elements)
  const rootComponent = Vue.extend(DynamicLink)

    // Loop through array and mount all elements
  arr.forEach(el => {
    new rootComponent({
      propsData: { ...el.dataset },
      i18n,
      store,
    }).$mount(el)
  })
}
